/**
 * @file Helpers for ComposeFooter component
 */

import { ComposeUpdates } from '../../../../containers/compose/composeFooter/types';
import { ComposeNodeType } from '../../../../containers/compose/props';
import { ComposeTypeParam } from '../../../../models/pageParams';

import ComposeFooterAttachment from './ComposeFooterAttachment';

import { ComposeFooterItem } from './types';

/**
 * All available items in the compose footer navigation
 */
const composeNavItems: ComposeFooterItem[] = [
  {
    composeNodeTypes: ['MESSAGE', 'TEMPLATE'],
    composeTypes: ['task'],
    label: 'MESSAGE__HEADING__STATUS',
    mode: 'status',
  },
  {
    CustomComponent: ComposeFooterAttachment,
    composeNodeTypes: ['MESSAGE'],
    composeTypes: ['post', 'task'],
    icon: 'attachFile',
    mode: 'attach',
  },
  {
    composeNodeTypes: ['MESSAGE', 'TEMPLATE'],
    composeTypes: ['post', 'task'],
    icon: 'label',
    mode: 'label',
  },
  {
    composeNodeTypes: ['MESSAGE', 'TEMPLATE'],
    composeTypes: ['post', 'task'],
    icon: 'checklist',
    mode: 'checklist',
  },
];

/**
 * Get the navigation items for the compose footer based on node and type
 *
 * @param composeNode The compose node to select tabs for
 * @param composeType The compose type to select tabs for
 * @param updates     The updates to check for changes
 *
 * @returns           Array of filtered items for the compose modal
 */
export const getComposeNavItems = (
  composeNode: ComposeNodeType,
  composeType: ComposeTypeParam,
  updates: Record<ComposeUpdates, boolean>,
): ComposeFooterItem[] => {
  return composeNavItems
    .filter(
      ({ composeNodeTypes, composeTypes }) =>
        composeNodeTypes.includes(composeNode) &&
        composeTypes.includes(composeType),
    )
    .map(item => ({ ...item, isChanged: updates[item.mode] }));
};
